import React, {useCallback, useEffect, useRef, useState } from 'react';

import eureka from 'eureka';
import eurekaMgrs from '@eureka/ui-managers';

import { MessageStrip } from '@ui5/webcomponents-react/dist/MessageStrip';
import { MessageStripType } from '@ui5/webcomponents-react/dist/MessageStripType';
import { Toast } from '@ui5/webcomponents-react/dist/Toast';
import { ToastPlacement } from '@ui5/webcomponents-react/dist/ToastPlacement';
import { createUseStyles } from 'react-jss';

const { useTranslation } = eureka.I18nProvider;
// eslint-disable-next-line
const useStyles = createUseStyles(({ parameters }) => ({
  toast: {
    '&::shadow': {},
  },
}));
const eventBus = eurekaMgrs.eventBus;
const MessageStripTypeEnum = {
  success: MessageStripType.Positive,
  warn: MessageStripType.Warning,
  warning: MessageStripType.Warning,
  info: MessageStripType.Information,
  error: MessageStripType.Negative,
  default: MessageStripType.Information,
};

const ToastPlugin = () => {
  const { t } = useTranslation();
  const toastRef = useRef();
  const classes = useStyles();
  const [toastProps, setToastProps] = useState({
    toastType: 'default',
    toastDuration: 3000,
    toastContent: '',
    toastPlacement: ToastPlacement.BottomCenter,
    toastIcon: null,
    iconContainerStyles: {},
    iconStyles: {},
  });

  const messageHandler = (message) => {
    /* istanbul ignore next */
    if (message?.content) {
      setToastProps({
        toastType: message.type,
        toastContent: message.content,
        toastDuration: message.duration,
        toastPlacement: message.placement || ToastPlacement.BottomCenter,
        messageStripType: MessageStripTypeEnum[message.type],
        noCloseButton: message.noCloseButton,
      });
    }
  };

  useEffect(() => {
    eventBus.on('on-message-toast', messageHandler);
    return () => {
      eventBus.detach('on-message-toast', messageHandler);
    };
  }, []);

  const removeDefaultStyles = () => {
    toastRef.current.getDomRef().style.padding = 0;
    toastRef.current.getDomRef().style.boxShadow = 'none';
    toastRef.current.getDomRef().style.maxWidth = 'none';
    toastRef.current.getDomRef().style.width = '600px';
    toastRef.current.getDomRef().style.textAlign = 'left';
  };

  /* istanbul ignore next */
  useEffect(() => {
    let current = toastRef && toastRef.current;
    if (current && toastProps.toastContent && toastProps.toastContent !== '') {
      current.show();
      window.requestAnimationFrame(removeDefaultStyles);
    }
    return () => {
      current = null;
    };
  }, [toastProps]);

  const onToastClose = useCallback(() => {
    toastRef?.current.removeAttribute('open');
  }, [toastRef]);

  let className = ' eureka-message-toast-layout ';
  className += `eureka-message-toast-type-${toastProps.toastType}`;

  return (
    <Toast
      duration={toastProps.toastDuration}
      placement={toastProps.toastPlacement}
      ref={toastRef}
      className={classes.toast}
    >
      <div className={className} style={{ display: 'flex' }}>
        <MessageStrip
          noCloseButton={toastProps.noCloseButton}
          noIcon={false}
          type={toastProps.messageStripType}
          onClose={onToastClose}
        >
          {t(toastProps.toastContent)}
        </MessageStrip>
      </div>
    </Toast>
  );
};

export default ToastPlugin;
